import React from 'react';

import Node from '../../Node';
import Search from '../../Search';
import Loader from '../../Loader';
import ArrowTooltipCss from '../../ArrowTooltipCss';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import MandatoryAlertIcon from './MandatoryAlertIcon';

export default ({
  rst,
  data,
  trpls,
  classes,
  constant,
  ancestorId,
  loadingTids,
  isAnotherNode,
  setLoadingTids,
  onNodeRemoveClick,
  disableTrplEditing,
  showMandatoryAlert,
  openObjectEditModal,
  disableNodeEditFormOpening,
  onNodeAddDropdownElementClick,
}) => {

  const isEditable = rst.obj_editable && `${rst.obj_editable}` === 'true';

  const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

  const dropdownElProps = {
    ancestor: ancestorId,
    rst,
  };

  return (
    <div
      key={`${rst.title}.${ancestorId}`}
    >
      {trpls.map((trpl, nodeIndex) => {
        if (trpl.tid) {
          return (
            <div
              key={`${rst.title}.${nodeIndex}`}
              className={`${classes.alignCenter} ${nodeIndex === 0 ? '' : classes.mt5}`}
              style={{
                height: '24px',
                justifyContent: 'space-between'
              }}
            >
              {!loadingTids.includes(trpl.tid) &&
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                  <Node
                    isLink
                    size="sm"
                    isRemovable={!constant && !disableTrplEditing}
                    nodeId={trpl.oid}
                    node={data.nodes[trpl.oid]}
                    nodes={data.nodes}
                    onRemoveClick={() => onNodeRemoveClick(rst, trpl, isAnotherNode ? ancestorId : null, setLoadingTids)}
                  />

                  {isEditable && !disableNodeEditFormOpening ? (
                    <div className={classes.editIconContainer}>
                      <ArrowTooltipCss text="Edit">
                        <EditIcon
                          className={classes.editNodeIcon}
                          onClick={() => openObjectEditModal('edit', trpl.oid, rst, rst.obj_editable_frm)}
                        />
                      </ArrowTooltipCss>
                    </div>
                  ) : null}
                </div>
              }
              {loadingTids.includes(trpl.tid) &&
                <div style={{ display: 'flex', alignItems: 'center', padding: '3px 0px 2px' }}>
                  <Loader style={{ zoom: '0.7', marginLeft: '10px' }} />
                </div>
              }
            </div>
          );
        } else {
          return (
            <div
              key={{nodeIndex}}
              className={`${classes.alignCenter} ${nodeIndex === 0 ? '' : classes.mt5}`}
              style={{
                height: '24px',
                justifyContent: 'space-between',
              }}
            >
              <div style={{height: '24px'}} className={`${classes.fw} ${classes.alignCenter}`}>
                <Search
                  rst={rst}
                  nodeId={ancestorId}
                  ancestorId={rst.oid}
                  filters={rst.trpl_filters}
                  setLoadingTids={setLoadingTids}
                  disableTrplEditing={disableTrplEditing}
                  onDropdownElementClick={onNodeAddDropdownElementClick}
                  onDropdownElementClickProps={dropdownElProps}
                  containerStyles={{
                    width: `calc (100% - 6px)`,
                    height: '23px',
                    backgroundColor: `${showMandatoryAlert ? '#FFD3B5' : ''}`,
                  }}
                  inputStyles={{
                    fontSize: '12px',
                    backgroundColor: `${showMandatoryAlert ? '#FFD3B5' : ''}`,
                  }}
                />

                {showMandatoryAlert && <MandatoryAlertIcon />}

                {isEditable && !disableTrplEditing ? (
                  <div className={classes.editIconContainer}>
                    <ArrowTooltipCss text="Add">
                      <AddIcon
                        className={classes.editNodeIcon}
                        style={{
                          fontSize: '24px',
                        }}
                        onClick={() =>
                          openObjectEditModal(
                            'create',
                            rst.oid,
                            rst,
                            rst.obj_editable_frm,
                            isAnotherNode ? ancestorId : null
                          )
                        }
                      />
                    </ArrowTooltipCss>
                  </div>
                ) : null}

                {loadingTids.includes(0) && <Loader style={{ zoom: '0.7', marginLeft: '10px' }} />}
              </div>
            </div>
          )
        }
      })
      }
    </div>
  );
};
